var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{class:{ 'on-hover': hover },attrs:{"min-height":"220px","elevation":hover ? 12 : 2}},[_c('v-card-title',[_c('router-link',{attrs:{"to":`/blog/fr/kite_guides_step_by_step`}},[_vm._v("Titre")])],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }